import { Divider, Chip } from '@mui/material'

const EndOfPage = () => {
  return (
    <Divider>
      <Chip label="Конец" size="small" />
    </Divider>
  )
}

export default EndOfPage
